import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PerinHealthGrid from '../../components/PerinHealthGrid';
import FilterManagementView from '../../components/FilterManagementView';
import managementStyles from '../ManagementPages.module.css';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import styles from './PatientSubmittedReports.module.css';
import useAxios from '../../services/AxiosConfig';
import { updatePatientInfo } from '../../slicers/PatientSlice';
import NewStatusBadge from '../../components/icons/NewStatusBadge';
import { resetFilterState } from '../patient/Slices/PatientDetailFilterSlice';
import { formatDateString } from '../../utils/dateUtils';
import { useWebSocket } from '../../services/webSocket/useWebSocket';

const PatientSubmittedReports = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDateFormat = useSelector((state) => state.userInfo.dateFormat);

    const [reportData, setReportData] = useState([]);

    const headers = [
        { key: 'id', label: "ID", sortable: true },
        { key: 'name', label: "Name", sortable: true },
        { key: 'date', label: "Date", sortable: true },
        { key: 'status', label: "Status", sortable: true },
        { key: 'openReportCount', label: "Reports", sortable: true }
    ];

    const getTotalNewReports = () => {
        return reportData.reduce((total, item) => total + (Math.min(item.newReportCount,1)), 0);
    };

    const totalNewReports = getTotalNewReports();

    const onRowClickHandler = (patient) => {
        dispatch(showAlert({
            header: "Redirecting",
            message: "Taking you to the patient details page.",
            type: 'info'
        }));
        dispatch(updatePatientInfo(patient.id));
        dispatch(resetFilterState());
        navigate('/patient-detail/Reports');
    };   
    
    const axiosConfig = useSelector((state) => state.axiosConfig);
    const userAccountId = useSelector((state) => state.userInfo.id);
    const axios = useAxios(axiosConfig.envURL);

    const checkForBadge = (item) => {
        if (item.newReportCount > 0 ) {
            return <NewStatusBadge count={item.newReportCount}/>;
        } else { return null};
    };

    const fetchData = async () => {
        try {
            const reportResponse = await axios.get(`/report/list/open/${userAccountId}`);
            const formatted = reportResponse.data.data.map(item => ({
                ...item,
                date: formatDateString(item.date, userDateFormat)
            }));
            setReportData(formatted);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [axios, userAccountId, userDateFormat]);
    

    const { receivedMessage } = useWebSocket();

    useEffect(() => {
        if (receivedMessage?.type === 'new_patient_submitted_report') {
            fetchData();
        }
      }, [receivedMessage]);


    return (
        <div className={managementStyles.MiddleContent}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <span className={styles.ReportsNumber}>{totalNewReports}</span>
                <span className={styles.ReportsLabel2} style={{ paddingLeft: "5px" }}>New Patient Reports</span>
            </div>
            <FilterManagementView
                isOrganization={false}
                isGroup={false}
                showAddButton={false}
                showDeleteButton={false}
            />
            <div className={managementStyles.GridContainer}>
                <PerinHealthGrid
                    dataList={reportData}
                    showProfilePicture={'name'}
                    headers={headers}
                    showCheckbox={false}
                    showHeaderFilter={true}
                    onRowValueClick={onRowClickHandler}
                    gridHeight='100%'
                    rowValueAction={'name'} 
                    showBadge={checkForBadge}
                />     
            </div>
        </div>
    );
}

export default PatientSubmittedReports;
